import TierGrid from './TierGrid';
export default TierGrid;

//# sourceMappingURL=index.js.map